export default [
  'OFICINA', 'NO CLIENTE', 'AMBOS'
]